import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/state/store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";
import i18n from "@/plugins/i18n.js";
import "@/utils/filters.js";
// Import Material Design Icons
import "@mdi/font/css/materialdesignicons.css";
// Ocultos hasta que cargue la fuente (ver tailwind.css)
if (document.fonts && document.fonts.load) {
  document.fonts
    .load('1em "Material Design Icons"')
    .then(() => document.documentElement.classList.add("mdi-ready"))
    .catch(() => {});
} else {
  document.documentElement.classList.add("mdi-ready");
}
// Globally register all `_base`-prefixed components
import "@/components/global/_globals";

// load layout
import LayoutDefault from "./layouts/LayoutDefault.vue";
Vue.component("LayoutDefault", LayoutDefault);
// for development load the components manually so it does not break with the devtool open
//https://github.com/vuejs/vue-devtools/issues/944 - vue-devtools issue
import LayoutError from "./layouts/LayoutError.vue";
Vue.component("LayoutError", LayoutError);
import LayoutLogged from "./layouts/LayoutLogged.vue";
Vue.component("LayoutLogged", LayoutLogged);
import LayoutLogin from "./layouts/LayoutLogin.vue";
Vue.component("LayoutLogin", LayoutLogin);
// end layout
import "./plugins/date-filter.js";
import "./plugins/chat.js";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
import "./assets/tailwind.css";
import "./registerServiceWorker";
// import "vue-toast-notification/dist/theme-sugar.css";

import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.snow.css";
Vue.use(VueToast);

Vue.config.productionTip = false;

// const HTTP = require("@/api/http.js");
// Vue.prototype.$http = HTTP;

//Custom settings file
const system_config = require("@/constants/config.json");
Vue.prototype.$system_config = system_config;

//Axios
axios.defaults.baseURL = process.env.VUE_APP_MAIN_ADMIN_API;
Vue.use(VueAxios, axios);

Vue.use(require("vue-moment"));

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});
// navigator.serviceWorker
//   .getRegistrations()
//   .then(function(registrations) {
//     for (let registration of registrations) {
//       registration.unregister();
//     }
//   })
//   .catch(function(err) {
//     console.log("Service Worker registration failed: ", err);
//   });

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
